export function usePodiumAuth() {
  const clientId = process.env.VUE_APP_PODIUM_CLIENT_ID;
  const redirectUri =
    typeof window !== 'undefined' ? window.location.origin : '';

  async function getAuthCode() {
    return new Promise((resolve, reject) => {
      if (!clientId) {
        return reject(new Error('Podium Client ID is not configured.'));
      }
      if (typeof window === 'undefined') {
        return reject(
          new Error('This function can only be run on the client side.'),
        );
      }

      // Podium OAuth scopes - adjust based on your needs
      const scope = [
        'read_messages',
        'write_messages',
        'read_locations',
        'read_payments',
        'read_reviews',
      ].join(' ');
      const responseType = 'code';
      const state = Math.random().toString(36).substring(7); // Add state for security

      const authUrl = new URL('https://accounts.podium.com/oauth/authorize');
      authUrl.searchParams.set('client_id', clientId);
      authUrl.searchParams.set('redirect_uri', redirectUri);
      authUrl.searchParams.set('scope', scope);
      authUrl.searchParams.set('response_type', responseType);
      authUrl.searchParams.set('state', state);

      const authWindow = window.open(
        authUrl.toString(),
        '_blank',
        'width=500,height=600',
      );

      const interval = setInterval(() => {
        try {
          if (authWindow && authWindow.location.href.startsWith(redirectUri)) {
            const url = new URL(authWindow.location.href);
            const code = url.searchParams.get('code');
            const returnedState = url.searchParams.get('state');

            clearInterval(interval);
            authWindow.close();

            if (code && returnedState === state) {
              resolve(code);
            } else {
              reject(
                new Error(
                  'No authorization code found or state mismatch in the redirect URI.',
                ),
              );
            }
          }
        } catch {
          if (authWindow && authWindow.closed) {
            clearInterval(interval);
            reject(new Error('Authorization window was closed by the user.'));
          }
        }
      }, 500);
    });
  }

  return { getAuthCode };
}
